import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function uploadFiles(file) {
  const formData = new FormData();
  formData.append("Filename", file);
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/document",
    options
  );

  if (!response.ok) {
    const data = await response.json();
    const errorMessage = data?.errors[0]?.description || "Unknown error";

    if (response.status === 401) {
      if (errorMessage === "Token Invalid or Expired") {
        throw new Error("Authentication error: Token Invalid or Expired");
      }
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return data;
  } else {
    return response;
  }
}
